import { today } from "../services/AppService";

export class ArchiveModel {
    ID: string = "0";
    Reason_Kind: string = "0";
    Parent_ID: string = "0";
    Date: string = today();
    Reason: string = "";
    Note: string = "";
}